var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"codebox",on:{"click":[_vm.showcode,function($event){$event.stopPropagation();}]}},[_c('img',{staticClass:"img",attrs:{"src":require("@/assets/images/user/code.png"),"alt":""}}),_c('div',{staticClass:"text"},[_vm._v("关注公众号，各种福利、活动、新品，都在这里！")])])
}
var staticRenderFns = []

export { render, staticRenderFns }